import React from "react";
import TableTopActions from "../../../components/crm/tables/TableTopActions";
import { useLocation } from "react-router-dom";
import { getColumns } from "../../../components/crm/tables/Columns";
import SelectionActionsModal from "../../../components/crm/forms/SelectionActionsModal";
import { FormattedMessage } from "react-intl";
import { ReactComponent as ClientsImg } from "../../../assets/no-clients.svg";
import { Table, Empty } from "antd";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import CrmTemplate from "../../../components/crm/CrmTemplate";
import { useSelector } from "react-redux";
import { usePatient_opportunity_statuses } from "../../../hooks";
import ConvertOrCreateWizard from "../opportunity/ConvertOrCreateWizard";
import TransferPatient from "../../patients/components/TransferPatient";
import { useUserBranches } from "../../../hooks/accessControl";
import { useOpportunitiesData } from "../hooks/useOpportunitiesData";
import { useOpportunitiesActions } from "../hooks/useOpportunitiesActions";

const Opportunities = () => {
  const intl = useIntl();
  let location = useLocation();
  const userBranches = useUserBranches();
  const dispatch = useDispatch();
  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  const patient_opportunity_statuses = usePatient_opportunity_statuses();
  const {
    createOpportunityVisible,
    selectionActionModalVisible,
    wizardType,
    selectionActionLoading,
    selectionAction,
    textFilter,
    transferPatientVisible,
    page,
    selectedRowKeys,
    onSelectChange,
    onLaunchCreateOpportunityModal,
    hideOpportunityModal,
    onLaunchSelectionActionModal,
    hideSelectionActionModal,
    onLaunchChangeBranch,
    onHideTransferPatient,
    onTextChange,
    onStaffInchargeChange,
    onChange,
  } = useOpportunitiesActions(patient_opportunity_statuses, location);
  const { data, isLoading, error, refetch } = useOpportunitiesData(
    page,
    scopePrefix
  );
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.id,
    }),
  };

  const pagination = {
    current: page && page.current,
    pageSize: page && page.pageSize,
    total: data && data.total,
  };

  return (
    <CrmTemplate>
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "10px",
          margin: "10px",
          boxShadow: "0 4px 9px 0 rgba(0, 0, 0, 0.05)",
          borderRadius: "5px",
        }}
      >
        <TableTopActions
          newAction={onLaunchCreateOpportunityModal}
          selectionAction={onLaunchSelectionActionModal}
          keys={selectedRowKeys}
          entity={"opportunities"}
          textFilter={textFilter}
          onTextChange={onTextChange}
          onStaffInchargeChange={onStaffInchargeChange}
        />
        <Table
          rowKey={(record) => record.id}
          columns={getColumns("opportunities", intl, location, dispatch, {
            patient_opportunity_statuses,
            onLaunchCreateOpportunityModal,
            onLaunchChangeBranch,
            userBranches,
          })}
          dataSource={data ? data.items : []}
          scroll={{
            y: window.innerHeight - 376,
          }}
          bordered
          locale={{
            emptyText: (
              <Empty
                image={!isLoading ? <ClientsImg /> : null}
                description={
                  !isLoading ? (
                    <FormattedMessage id={"app.tables.noData"} />
                  ) : null
                }
              />
            ),
          }}
          rowSelection={rowSelection}
          pagination={data && pagination}
          onChange={onChange}
          loading={isLoading}
        />

        <ConvertOrCreateWizard
          visible={createOpportunityVisible}
          hide={hideOpportunityModal}
          type={wizardType}
          fromCrm={true}
          refetch={refetch}
        />
        <SelectionActionsModal
          visible={selectionActionModalVisible}
          hide={hideSelectionActionModal}
          loading={selectionActionLoading}
          keys={selectedRowKeys}
          entity={"opportunities"}
          selectionAction={selectionAction}
        />
        <TransferPatient
          visible={transferPatientVisible}
          hide={onHideTransferPatient}
        />
      </div>
    </CrmTemplate>
  );
};
export default Opportunities;
